import './App.css';
import { useState } from 'react';

function App() {
  const [mensagem, setMensagem] = useState('');
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [usuarioLogado, setUsuarioLogado] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMensagem('');
    try {
      const response = await fetch('https://logiai.tabinfo.com.br/backend/index.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, senha })
      });
      const data = await response.json();
      if (data.usuario) {
        setUsuarioLogado(data.usuario);
        setMensagem('Login realizado com sucesso!');
      } else {
        setUsuarioLogado(null);
        setMensagem(data.mensagem || 'Usuário ou senha inválidos.');
      }
    } catch (error) {
      setMensagem('Erro ao conectar ao backend.');
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Bem-vindo ao site!</h1>
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 8, width: 250 }}>
          <input
            type="text"
            placeholder="Usuário"
            value={login}
            onChange={e => setLogin(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={e => setSenha(e.target.value)}
            required
          />
          <button type="submit">Entrar</button>
        </form>
        {mensagem && <p>{mensagem}</p>}
        {usuarioLogado && (
          <div style={{ marginTop: 16 }}>
            <strong>Bem-vindo, {usuarioLogado.login || usuarioLogado.nome || 'usuário'}!</strong>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;
